import type { ComponentProps } from "react";
import { BarVisualizer } from "@livekit/components-react";
import { PhoneSvg, SpinnerSvg } from "../icons";

type VisualizerProps = ComponentProps<typeof BarVisualizer>;

export function CallButton({
  onClick,
  active,
  connecting,
  size,
  showVisualizer,
  agentState,
  microphoneTrack,
}: {
  onClick: () => void;
  active: boolean;
  connecting: boolean;
  size: "sm" | "lg";
  showVisualizer?: boolean;
  agentState?: VisualizerProps["state"];
  microphoneTrack?: VisualizerProps["track"];
}) {
  const label = connecting ? "Connecting..." : active ? "End voice call" : "Start voice call";

  // Active voice mode: render the orange pill with phone icon + waveform
  if (active || connecting) {
    return (
      <button
        type="button"
        className={`lk-widget-call-pill${connecting ? " lk-widget-call-pill--connecting" : ""}`}
        onClick={onClick}
        disabled={connecting}
        aria-label={label}
        title={label}
      >
        {connecting ? SpinnerSvg : PhoneSvg}
        {showVisualizer && agentState && (
          <div className="lk-widget-call-pill-visualizer">
            <BarVisualizer state={agentState} track={microphoneTrack} barCount={5} />
          </div>
        )}
      </button>
    );
  }

  // Inactive: original circle button
  return (
    <button
      type="button"
      className={`lk-widget-call-btn lk-widget-call-btn--${size}`}
      onClick={onClick}
      disabled={connecting}
      aria-label={label}
      title={label}
    >
      {PhoneSvg}
    </button>
  );
}
